import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SUPPORT_EMAIL, Section, WHATSAPP_LABEL, WHATSAPP_URL } from './Shared';
import { FretDivider } from './Ornaments';
export function Guarantee() {
  return <Section className="max-w-3xl" data-id="element-88" data-mp="32p5nojgp12qd">
      <div className="paper-card rounded-sm border border-brand-forest/35 p-8 text-center shadow-[0_12px_34px_rgba(44,38,32,0.08)] md:p-12" data-id="element-89" data-mp="32lrn9grlb3lk">
        <ShieldCheckIcon className="mx-auto h-14 w-14 text-brand-forest" aria-hidden="true" data-id="element-90" data-mp="3uesb1j9yv7im" />
        <h2 className="mt-5 font-display text-3xl font-bold text-brand-ink" data-id="element-91" data-mp="37fu95czww38">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <FretDivider character="信" className="mt-5" data-id="element-92" data-mp="3lggbgrr4gze1" />
        <p className="mt-5 text-brand-text" data-id="element-93" data-mp="3qcdtd2i1adsx">
          Descargás el Atlas. Abrís el Tomo II. Lo usás en tu próxima sesión
          clínica.
        </p>
        <p className="mt-4 text-brand-text" data-id="element-94" data-mp="2a1jkhcbdo041">
          Si en 7 días no es exactamente lo que esperabas: devolución del 100%
          sin formularios, sin drama, sin preguntas.
        </p>
        <p className="mt-6 font-semibold text-brand-forest" data-id="element-95" data-mp="3lbmvdvr3pehh">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </Section>;
}
export function Footer() {
  return <footer className="border-t border-brand-gold/40 bg-brand-ink py-12 text-brand-paper" data-id="element-96" data-mp="3v91bfu944199">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-97" data-mp="3q727oj9gn2bs">
        <p className="font-kanji text-2xl text-brand-goldLight/70" aria-hidden="true" data-id="element-98" data-mp="81ywqhwtbw3g">
          針灸
        </p>
        <h3 className="mt-2 font-display text-3xl font-bold tracking-[0.06em] text-brand-goldLight" data-id="element-99" data-mp="335pv8c173c9">
          LUMEN AKASHA™
        </h3>
        <p className="mx-auto mt-3 max-w-2xl text-white/80" data-id="element-100" data-mp="huo4p2t5mru1">
          El sistema visual de acupuntura clínica N°1 para terapeutas en
          Argentina.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-white/70" data-id="element-101" data-mp="qu1ejwl6xifa">
          Porque aplicar Medicina Tradicional China con excelencia no debería
          depender de cuánto recordás ese día.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 text-sm text-brand-goldLight sm:flex-row sm:gap-7" data-id="element-102" data-mp="two4hv2q1j7u">
          <a className="transition-colors hover:text-brand-paper" href={`mailto:${SUPPORT_EMAIL}`} data-id="element-103" data-mp="yruzmehxdfl5">
            📧 {SUPPORT_EMAIL}
          </a>
          <a className="transition-colors hover:text-brand-paper" href={WHATSAPP_URL} data-id="element-104" data-mp="18lbvdo1mh4rg">
            📱 WhatsApp: {WHATSAPP_LABEL}
          </a>
          <a className="transition-colors hover:text-brand-paper" href="https://instagram.com/lumen.akasha" data-id="element-105" data-mp="1hje1gi07qnll">
            📷 @lumen.akasha
          </a>
          <a className="transition-colors hover:text-brand-paper" href="https://www.lumenakasha.com" data-id="element-106" data-mp="1rhttqoaz82wo">
            🌐 www.lumenakasha.com
          </a>
        </div>
        <div className="mt-10 space-y-2 text-xs text-white/50" data-id="element-107" data-mp="3tb9mbqqmjrua">
          <p data-id="element-108" data-mp="2af3ubumo9blq">
            © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-109" data-mp="25maot4jdpz8l">
            Ley 25.326 — Protección de Datos Personales — República Argentina
          </p>
        </div>
        <p className="mt-8 font-display text-sm italic text-brand-goldLight/75" data-id="element-110" data-mp="1wnpa5kh134d3">
          “El terapeuta que tiene un sistema aplica con confianza. El que aplica
          con confianza genera resultados. El que genera resultados crece.”
        </p>
      </div>
    </footer>;
}